import type { SVGProps } from 'react';

interface ArrowUpIconProps extends SVGProps<SVGSVGElement> {
    color?: string;
    width?: number | string;
    height?: number | string;
    className?: string;
    svgProps?: SVGProps<SVGSVGElement>;
}

const ArrowUpIcon = ({ color = 'currentColor', width = 16, height = 16, className, svgProps }: ArrowUpIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 16" fill="none" className={className} {...svgProps}>
            <path
                d="M12.7901 7.83696C13.716 7.83696 14.1446 6.68716 13.4447 6.08103L7.65496 1.06695C7.27919 0.741519 6.72143 0.741518 6.34565 1.06695L0.555892 6.08103C-0.144011 6.68716 0.284659 7.83696 1.21054 7.83696H3.23944C3.51558 7.83696 3.73944 8.06081 3.73944 8.33696V14.5C3.73944 15.0523 4.18715 15.5 4.73944 15.5H9.26118C9.81346 15.5 10.2612 15.0523 10.2612 14.5V8.33696C10.2612 8.06081 10.485 7.83696 10.7612 7.83696H12.7901Z"
                fill={color}
            />
        </svg>
    );
};

export default ArrowUpIcon;
